import React from "react";

const money = (v) =>
  Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const Bloco = ({ bloco }) => {
  if (!bloco) return null;
  return (
    <section className="mt-8">
      <h3 className="text-sm font-bold tracking-wide text-gray-800 dark:text-slate-100 uppercase">
        {bloco.titulo}
      </h3>
      <div className="mt-3 overflow-x-auto zen-card rounded-2xl border border-gray-200 dark:border-white/10">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50 dark:bg-white/5 text-left text-gray-600 dark:text-slate-300">
            <tr>
              <th className="py-2 px-3">CNPJ</th>
              <th className="py-2 px-3">Razão social</th>
              <th className="py-2 px-3">Produto</th>
              <th className="py-2 px-3 text-right">Total</th>
            </tr>
          </thead>
          <tbody>
            {(bloco.linhas || []).map((l) => (
              <tr key={`${l.clienteId}-${l.produto}`} className="border-t border-gray-100 dark:border-white/10">
                <td className="py-2 px-3 whitespace-nowrap">{l.cnpj}</td>
                <td className="py-2 px-3">{l.razaoSocial}</td>
                <td className="py-2 px-3">{l.produto}</td>
                <td className="py-2 px-3 text-right whitespace-nowrap">{money(l.total)}</td>
              </tr>
            ))}
            {(bloco.linhas || []).length === 0 && (
              <tr>
                <td colSpan={4} className="py-6 text-center text-gray-500">Nenhuma licença neste bloco.</td>
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr className="border-t border-gray-200 dark:border-white/10 font-semibold">
              <td colSpan={3} className="py-2 px-3">Total do bloco</td>
              <td className="py-2 px-3 text-right">{money(bloco.total)}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </section>
  );
};

const RelatorioComposicaoView = ({ dados }) => {
  if (!dados) return null;
  return (
    <div>
      <div className="border-b border-gray-200 dark:border-white/10 pb-4">
        <h2 className="text-xl font-bold uppercase text-gray-900 dark:text-white">{dados.titulo}</h2>
        <p className="text-sm text-gray-500 dark:text-slate-400 mt-1">Período {dados.periodo}</p>
      </div>

      <Bloco bloco={dados.diretas} />
      {(dados.revendas || []).map((b) => (
        <Bloco key={b.revendaId || b.titulo} bloco={b} />
      ))}

      <section className="mt-8 text-sm text-gray-800 dark:text-slate-100 space-y-1">
        <p className="font-semibold">Qtde de clientes = {dados.qtdeClientes || 0}</p>
        {(dados.contagens || []).map((c) => (
          <p key={c.chave}>
            Qtde {c.nome} = {c.quantidade}
          </p>
        ))}
        <p className="pt-3 text-base font-bold">Total {money(dados.total)}</p>
      </section>
    </div>
  );
};

export default RelatorioComposicaoView;
